export default __webpack_public_path__ + "static/media/logo.2375c1c8.svg";